<template>
  <div class="main">
    <div class="left-container" ref="left-container">
      <div>
        <button class="menu-action" @click="menuClicked">
          <img
            class="menu-action-icon"
            src="https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png"
            alt="New Trip"
          />
          New Trip
        </button>
        <button class="menu-action" @click="menuClicked">
          <img
            class="menu-action-icon"
            src="https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png"
            alt="Cancel Trip(s)"
          />
          Cancel Trip(s)
        </button>
      </div>
      <div ref="top-height">
        <BoxContainer style="background-color: white" title="Filter">
          <div style="height: fit-content" ref="select-by-cont-box">
            <div class="work-ticket-section">
              <Dropdown
                :isRequired="true"
                placeholder="Field"
                :items="fieldItemsOption"
                itemKey="Field"
                :selectedObject.sync="selectedField"
              />
              <div class="separator"></div>
              <DateTimePicker
                :value.sync="dateFrom"
                :isRequired="true"
                style="margin"
                :isDisabled="allChecked"
                v-if="useDateInput"
                placeholder="From"
                :showTime="false"
                :errorMessage.sync="fromDateError"
              />
              <DateTimePicker
                :value.sync="dateTo"
                :isRequired="true"
                :isDisabled="allChecked"
                v-if="useDateInput"
                style="margin-right: -3"
                placeholder="To"
                :showTime="false"
                :errorMessage.sync="toDateError"
              />
              <Filters
                style="height: 120px; width: 100%; padding-top: 3px"
                v-if="!useDateInput"
                :title="selectedField ? fromToFullKey : ''"
                :tableData="fieldItems"
                :itemKey="fromToFullKey"
                :selectedObject.sync="selectedFields"
                noneSelectedText="None"
                noneSelectedConfirmButtonText="Select None"
              />
            </div>
          </div>
          <Filters
            v-if="!hideDriverFilter"
            title="Drivers"
            :tableData="drivers"
            itemKey="Driver"
            style="height: 120px; width: 100%; padding-top: 3px"
            :selectedObject.sync="selectedDrivers"
            noneSelectedText="None"
            noneSelectedConfirmButtonText="Select None"
          />
        </BoxContainer>
        <button
          style="width: 100%; margin-top: 10px"
          :style="{ backgroundColor: refreshFlashing ? undefined : '' }"
          :class="{ 'refresh-flashing': refreshFlashing }"
          @click="refreshClicked"
          >Refresh</button
        >
        <div class="separator"></div>
      </div>
      <div class="cardlist-styling" :style="cardlistStyling">
        <div>
          <div style="display: flex; justifycontent: flex-end; margin: 5px">
            <button @click="selectAllClicked">{{
              selectedWorkTicketItem.length > 0 ? 'Deselect All' : 'Select All'
            }}</button>
          </div>
          <div style="display: flex; justifycontent: flex-end; margin: 5px" v-if="workTicketItem"
            >Selected {{ selectedWorkTicketItem.length }} of {{ workTicketItem.length }} record(s)</div
          >
          <div v-if="workTicketItem">
            <div
              v-for="(w, i) in workTicketItem"
              :key="i"
              class="card"
              :style="{
                marginBottom: '4px',
                cursor: 'pointer',
                backgroundColor:
                  selectedWorkTicketItem.length > 0 ?
                    selectedWorkTicketItem.includes(w) ?
                      'rgb(120, 120, 255)'
                    : ''
                  : '',
                color:
                  selectedWorkTicketItem.length > 0 ?
                    selectedWorkTicketItem.includes(w) ?
                      'white'
                    : ''
                  : '',
              }"
              @click="cardClick(w)"
            >
              <div class="card-filtered-items" style="display: flex; flex-direction: row; margin-left: 5px">
                <div class="filter-title">Date</div>
                <div class="colon-separator">:</div>
                <div class="filter-details">{{ w['jidate'] || null }}</div>
              </div>
              <div class="card-filtered-items" style="display: flex; flex-direction: row; margin-left: 5px">
                <div class="filter-title">Work Ticket #</div>
                <div class="colon-separator">:</div>
                <div class="filter-details">{{ w['jino'] || null }}</div>
              </div>
              <div class="card-filtered-items" style="display: flex; flex-direction: row; margin-left: 5px">
                <div class="filter-title">PM</div>
                <div class="colon-separator">:</div>
                <div class="filter-details">{{ w['primemover'] || null }}</div>
                <div style="margin-left: 25px"></div>
                <div class="filter-title">Driver</div>
                <div class="colon-separator">:</div>
                <div class="filter-details">{{ w['driver'] || null }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="right-container">
      <div class="top-right-container" ref="top-right-container">
        <div class="filtered-section" style="flex: 0 0 30%">
          <div class="filtered-items" v-if="selectedWorkTicketItem.length < 2">
            <div style="width: 100px">Date</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">{{ headerDate }} &nbsp; &nbsp;</div>
            <div style="width: 100px">Shift</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">{{ headerShift || '' }}</div>
          </div>
          <div class="filtered-items">
            <div class="filter-title">Driver</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">{{ headerCode }} &nbsp; &nbsp; &nbsp;{{ headerName }}</div>
          </div>
          <div class="filtered-items">
            <div class="filter-title">Attendant</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">{{ headerAttCode }}&nbsp; &nbsp; &nbsp; {{ headerAttName }}</div>
          </div>
          <div class="filtered-items" v-if="headerPrimeMoverGroup.length < 2">
            <div class="filter-title">PM</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">{{ headerPrimeMover }} &nbsp; &nbsp; &nbsp; {{ headerVehicleNo }}</div>
          </div>
        </div>
        <div
          class="filtered-section"
          v-if="
            selectedDrivers ?
              selectedDrivers.length == 1 ?
                true
              : false
            : true
          "
        >
          <div class="filtered-items">
            <div class="filter-title-left">Total Toll</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">{{ headerTotalToll ? $currencyFormat(parseFloat(headerTotalToll)) : 0 }}</div>
          </div>
          <div class="filtered-items">
            <div class="filter-title-left">Total Inc.</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">{{ headerTotalInc ? $currencyFormat(parseFloat(headerTotalInc)) : 0 }}</div>
          </div>
          <div class="filtered-items">
            <div class="filter-title-left">Est. KM travelled</div>
            <div class="colon-separator">:</div>
            <div class="filter-details"></div>
          </div>
          <div class="filtered-items">
            <div class="filter-title-left">Est. Time Taken(hrs)</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">{{ headerTimeTaken }}</div>
          </div>
        </div>
        <div
          class="filtered-section"
          v-if="
            selectedDrivers ?
              selectedDrivers.length == 1 ?
                true
              : false
            : true
          "
        >
          <div class="filtered-items">
            <div class="filter-title-left">Basic Comm.</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">
              <p v-if="selectedTrip.length > 0" style="text-align: end; height: 18px; color: blue"
                >{{ basicComSelected ? $currencyFormat(basicComSelected) : 0 }}/</p
              >
              <p style="text-align: end; height: 18px; color: black">{{ basicCom ? $currencyFormat(basicCom) : 0 }}</p>
            </div>
          </div>
          <div class="filtered-items">
            <div class="filter-title-left">Special Inc.</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">
              <p v-if="selectedTrip.length > 0" style="text-align: end; width: 100%; color: blue"
                >{{ specialIncSelected ? $currencyFormat(specialIncSelected) : 0 }}/</p
              >
              <p style="text-align: end; width: 100%; color: black">{{
                specialInc ? $currencyFormat(specialInc) : 0
              }}</p>
            </div>
          </div>
          <div class="filtered-items">
            <div class="filter-title-left">Other Inc</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">
              <p v-if="selectedTrip.length > 0" style="text-align: end; width: 100%; color: blue"
                >{{ otherIncSelected ? $currencyFormat(otherIncSelected) : 0 }}/</p
              >
              <p style="text-align: end; width: 100%; color: black">{{ otherInc ? $currencyFormat(otherInc) : 0 }}</p>
            </div>
          </div>
          <div class="filtered-items">
            <div class="filter-title-left">Total</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">
              <p v-if="selectedTrip.length > 0" style="text-align: end; width: 100%; color: blue"
                >{{ totalSelected ? $currencyFormat(totalSelected) : 0 }}/</p
              >
              <p style="text-align: end; width: 100%; color: limegreen">{{ total ? $currencyFormat(total) : 0 }}</p>
            </div>
          </div>
        </div>
        <!-- <div class="filtered-section" style="flex: 0 0 160px">
          <button style="margin-right: 5px; margin-left: 5px; margin-bottom: 5px">
            <img src="https://dsmlib.logistics.systems/Icons/toll.png" height="15px" /> Toll Expenses
          </button>
          <button style="margin-right: 5px; margin-left: 5px; margin-bottom: 5px">
            <img src="https://dsmlib.logistics.systems/Icons/icons8-oil-industry-64.png" height="15px" /> Fuel Expenses
          </button>
        </div> -->
      </div>
      <div class="botttom-right-container" ref="botttom-right-container" :style="{ height: 'calc(100% - 85px)' }">
        <div class="botttom-right-container-top" :style="{ height: 'calc(100% - 85px)' }">
          <div
            :style="{
              margin: '5px',
              width: editClicked || updateClicked ? '60%' : '100%',
              overflow: 'auto',
              height: 'calc(100% - 10px)',
            }"
          >
            <TableBox
              title="Trip Listing"
              groupBy="JINo"
              :showSelectAll="true"
              :hideColumns="['JINo', 'Time Taken', 'JourneyGUID', 'Icon', 'D/C', 'Type', 'Job #']"
              :additionalButtons="viewMode ? [] : additionalButtons"
              :tableData="cardSelectedList"
              :selectedRow.sync="selectedTrip"
              :maxSelection="-1"
              :loading="!showTable"
              :dataType="{
                Toll: 'currency',
                Basic: 'currency',
                Special: 'currency',
                Other: 'currency',
                AttnBasic: 'currency',
                DGC: 'currency',
                Rebate: 'currency',
                'Seq No': 'number',
              }"
              @buttonClicked="additionalTripButtonClicked"
            />
          </div>
          <div
            v-if="editClicked && !updateClicked"
            :style="{
              marginLeft: '5px',
              width: editClicked && !updateClicked ? '40%' : '0%',
            }"
          >
            <div style="width: 100%; text-align: center">Trip(s) Update</div>
            <div v-if="selectedTrip.length < 2" style="display: flex; flex-direction: row">
              <Input
                placeholder="Meter Start"
                style="width: 40%; margin-right: 5px; text-align: right"
                :inputValue.sync="mvt['meterStart']"
                :errorMessage.sync="meterStartError"
                :isDisabled="editTrip"
                :regex="{ regex: /^[1-9]\d*/g, live: true, autoClear: false }"
              />
              <DateTimePicker
                :errorMessage.sync="startDateError"
                placeholder="Start Time"
                :value.sync="mvt['startTime']"
                :isDisabled="editTrip"
              />
            </div>
            <div v-if="selectedTrip.length < 2" style="display: flex; flex-direction: row">
              <Input
                placeholder="Meter End"
                style="width: 40%; margin-right: 5px"
                :inputValue.sync="mvt['meterEnd']"
                :isDisabled="editTrip"
                :errorMessage.sync="meterEndError"
                :regex="{ regex: /^[1-9]\d*/g, live: true, autoClear: false }"
              />
              <DateTimePicker
                :errorMessage.sync="endDateError"
                placeholder="End Time"
                :value.sync="mvt['endTime']"
                :isDisabled="editTrip"
              />
            </div>
            <Input
              v-if="selectedTrip.length < 2"
              placeholder="Toll"
              style="width: 40%"
              :inputValue.sync="mvt['toll']"
              :isDisabled="editTrip"
              :regex="{ regex: /^\d*\.?\d{0,2}/g, live: true, autoClear: false }"
            />
            <Input
              v-if="selectedTrip.length < 2"
              placeholder="DGC"
              style="width: 40%"
              :inputValue.sync="mvt['dgc']"
              :isDisabled="editTrip"
              :regex="{ regex: /^\d*\.?\d{0,2}/g, live: true, autoClear: false }"
            />
            <Input
              v-if="selectedTrip.length < 2"
              placeholder="Other Inc"
              style="width: 40%"
              :inputValue.sync="mvt['otherInc']"
              :isDisabled="disabledOtherInc"
              :regex="{ regex: /^\d*\.?\d{0,2}/g, live: true, autoClear: false }"
            />
            <!-- <div style="width: 100%; text-align: center">Select the checkbox to select field(s) to update</div> -->
            <div style="display: flex; flex-direction: row">
              <!-- <CheckBox :isDisabled="viewMode" title="" :isChecked.sync="defaultChecked" @checkBoxClicked="checkBoxClicked('Attendant')" /> -->
              <InputQuery
                placeholder="Attendant"
                :items="attItemsOption"
                itemKey="Attendant Code"
                descKey="Attendant Name"
                :selectedObject.sync="selectedAtt"
              />
            </div>
            <div style="display: flex; flex-direction: row">
              <!-- <CheckBox :isDisabled="viewMode" title="" :isChecked.sync="defaultChecked" @checkBoxClicked="checkBoxClicked('Commission')" /> -->
              <InputQuery
                placeholder="Commission"
                :items="comItemsOption"
                itemKey="Com Code"
                descKey="Remark"
                :selectedObject.sync="selectedCom"
              />
            </div>
            <div style="display: flex; flex-direction: row; width: 50%">
              <!-- <CheckBox :isDisabled="viewMode" title="" :isChecked.sync="defaultChecked" @checkBoxClicked="checkBoxClicked('Ref #')" /> -->
              <Input placeholder="Ref #" :inputValue.sync="refNo" />
            </div>
            <div style="display: flex; flex-direction: row; width: 100%">
              <!-- <CheckBox :isDisabled="viewMode" title="" :isChecked.sync="defaultChecked" @checkBoxClicked="checkBoxClicked('Team')" /> -->
              <InputQuery
                placeholder="Team"
                :items="teamItemsOption"
                itemKey="Team"
                descKey="Description"
                :selectedObject.sync="selectedTeam"
              />
            </div>
            <RemarksBox
              v-if="selectedTrip.length < 2"
              :maxLength="200"
              placeholder="Remarks"
              style="height: 20%"
              :text.sync="mvt['remarks']"
              :isDisabled="editTrip"
            />
            <div style="display: flex; justifycontent: flex-end">
              <button @click="saveButton" style="margin: 3px; background-color: green; color: white">Save</button>
              <button @click="cancelButton" style="margin: 3px; background-color: red; color: white">Cancel</button>
            </div>
          </div>
        </div>

        <div class="botttom-right-container-bottom" style="">
          <div class="buttons-section">
            <div class="message-box" ref="msgbox">{{ approveResultMessage }}</div>
            <div style="display: flex; flex-direction: column; width: 250px; justify-content: flex-end">
              <!-- <button v-if="ticket" title="View selected CDA details" style="margin: 3px; height: 35px">
                  <img src="https://dsmlib.logistics.systems/Icons/icons8-product-documents-64.png" height="25"/>
                </button> 
                <button v-if="ticket" title="View container details for selected CDA" style="margin: 3px; height: 35px">
                  <img src="https://dsmlib.logistics.systems/Icons/icons8-list-64.png" height="25"/>
                </button>
                <button @click="addTrip" :title="ticket ? 'Insert New Trip' : 'Add Trip' " style="margin: 3px; height: 35px">
                  <img src="https://dsmlib.logistics.systems/Icons/icons8-add-64.png" height="25"/>
                </button>
                <button @click="removeTrip" :title="ticket ? 'Cancel Trips(s)' : 'Delete Trip' " style="margin: 3px; height: 35px">
                  <img src="https://dsmlib.logistics.systems/Icons/icons8-minus-64 (2).png" height="25"/>
                </button> -->
              <button title="Approve Trip(s)" style="margin: 3px; height: 35px" @click="approveClicked('approved')">
                <img src="https://dsmlib.logistics.systems/Icons/Save.png" height="25" />
                Approve Trip(s)
              </button>
              <button title="Unapprove Trip(s)" style="margin: 3px; height: 35px" @click="approveClicked('cancel')">
                <img src="https://dsmlib.logistics.systems/Icons/error.png" height="25" />
                Unapprove Trip(s)
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PopupV2
      :show="showNewTripPopup"
      title="New Trip"
      :buttons="newTripPopupButtons"
      @buttonClicked="newTripPopupSaveClicked"
      icon="-"
      width="25%"
      height="85%"
    >
      <div class="popup-body">
        <div class="form-row">
          <div v-if="showDriverField" class="input-field" style="width: 50%">
            <InputQuery
              placeholder="Driver"
              :items="drivers"
              itemKey="Driver"
              :selectedObject.sync="newTripDriver"
              :isDisabled="newTripDriverDisabled"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="input-field" style="width: 50%">
            <Dropdown
              placeholder="Type"
              :items="tripTypeItems"
              itemKey="text"
              :selectedObject.sync="tripTypeSelected"
              @selected="GetTripTypeSelected"
              :isDisabled="tripTypeSelectedDisabled"
            />
          </div>
          <div class="input-field">
            <CheckBoxV2
              v-if="showFinishTripChkBox"
              title="Finish Trip?"
              :isChecked.sync="finishTrip"
              :isDisabled="finishTripDisabled"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="input-field" style="width: 69%">
            <InputQuery
              placeholder="Consignment No"
              :items="cnList"
              itemKey="Consignment #"
              :selectedObject.sync="selectedCN"
              @selected="CNNoSelected"
              :isDisabled="selectedCNDisabled"
            />
          </div>
          <div class="input-field">
            <button @click="viewCNDetClicked" :disabled="!selectedCN">View CN Details</button>
          </div>
        </div>
        <div class="form-row">
          <Input
            placeholder="Container #"
            :inputValue.sync="containerNoInputValue"
            :isDisabled="containerNoInputValueDisabled"
          />
        </div>
        <div class="form-row">
          <Dropdown
            placeholder="Movement"
            :items="movementTypeItems"
            itemKey="Movement - Movement Desc"
            :selectedObject.sync="movementTypeSelected"
            @selected="movementTypeChange"
            :isDisabled="movementTypeSelectedDisabled"
          />
        </div>
        <div class="form-row">
          <div class="input-field" style="width: 48%">
            <DateTimePicker placeholder="From" :value.sync="tripFromDate" :isDisabled="tripFromDateDisabled" />
          </div>
          <div class="input-field" style="width: 48%">
            <DateTimePicker placeholder="To" :value.sync="tripToDate" :isDisabled="tripToDateDisabled" />
          </div>
        </div>
        <div class="form-row">
          <div class="input-field" style="width: 48%">
            <Input placeholder="Orig. From" :isDisabled="true" :inputValue.sync="selectedFromInput" />
          </div>
          <div class="input-field" style="width: 48%">
            <Input placeholder="Orig. To" :isDisabled="true" :inputValue.sync="selectedToInput" />
          </div>
        </div>
        <div class="form-row">
          <div class="input-field" style="width: 48%">
            <InputQuery
              placeholder="From Dest."
              :items="destinationList"
              itemKey="Location Code"
              :selectedObject.sync="selectedFrom"
              :isDisabled="selectedFromDisabled"
            />
          </div>
          <div class="input-field" style="width: 48%">
            <InputQuery
              placeholder="To Dest."
              :items="destinationList"
              itemKey="Location Code"
              :selectedObject.sync="selectedTo"
              :isDisabled="selectedToDisabled"
            />
          </div>
        </div>
        <div class="form-row" style="height: 200px; padding-bottom: 5px">
          <RemarksBox
            title="Remarks"
            :maxLength="200"
            :text.sync="newTripRemarks"
            :isDisabled="newTripRemarksDisabled"
          />
        </div>
        <div v-if="selectedWorkTicketItem.length != 1" class="form-row">
          <InputQuery
            placeholder="PM"
            :items="pmList"
            itemKey="PM Code - PM Number"
            :selectedObject.sync="selectedPM"
            :isDisabled="selectedPMDisabled"
            :isRequired="true"
            :errorMessage.sync="selectedPMErrMsg"
          />
        </div>
        <div class="form-row">
          <InputQuery
            placeholder="Trailer"
            :items="trList"
            itemKey="Trailer # - Trailer Code"
            :selectedObject.sync="selectedTRNo"
            :isDisabled="selectedTRNoDisabled"
          />
        </div>
        <div v-if="selectedWorkTicketItem.length != 1" class="form-row">
          <InputQuery
            placeholder="Attendant"
            :items="driverList"
            itemKey="Code - Name"
            :selectedObject.sync="selectedDriver"
            :isDisabled="selectedDriverDisabled"
          />
        </div>
      </div>
    </PopupV2>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    cardlistStyling: function () {
      return {
        height: `calc( ${this.leftContainer} - ${this.topHeight})px`,
      };
    },
    filtersSnapshot: function () {
      return JSON.stringify({
        selectedField: this.selectedField,
        selectedFields: this.selectedFields,
        selectedDrivers: this.selectedDrivers,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      });
    },
    showDriverField: function () {
      if (!this.hideDriverFilter) {
        return this.selectedDrivers?.length != 1;
      }
      return this.selectedFields?.length != 1;
    },
  },
  data: function () {
    return {
      multipleUpdate: false,
      loadingTable: true,
      disabledOtherInc: false,
      // tempCardSelected: [],

      // menu: [
      //   { title: 'Driver Commission Overview', icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png', enabled: true },
      //   { title: 'Status Tracking', icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png', enabled: true },
      //   { title: 'Workticket W/O HQ Approval', icon: 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png', enabled: true },
      //   { title: 'Detail New Movement', icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png', enabled: true },
      // ],

      additionalButtons: [
        { text: 'Edit', index: 0, width: 65 },
        // { text: 'Update Details', index: 1, width: 140 }
      ],
      // tripStatusMap : new Map(),
      fromDateError: '',
      toDateError: '',
      startDateError: '',
      endDateError: '',
      hideDriverFilter: false,
      viewMode: false,
      allChecked: false,
      useDateInput: false,
      sectionHeight: 0,
      topHeight: 0,
      leftContainer: 0,
      tableBoxHeight: 0,
      topSecHeight: 0,
      fieldItemsOption: [],
      selectedField: null,
      attItemsOption: [],
      selectedAtt: null,
      comItemsOption: [],
      selectedCom: null,
      teamItemsOption: [],
      selectedTeam: null,
      fieldItems: [],
      tempResultError: [],
      refNo: '',
      selectedFields: null,
      selectedDrivers: null,
      workTicketItem: [],
      workTicketLoading: false,
      selectedWorkTicketItem: [],
      fromToFullKey: '',
      cardSelectedList: [],
      showTable: true,
      cardSelected: null,
      getTripListingItem: null,
      selectedTrip: [],
      headerDate: '',
      headerShift: '',
      headerCode: '',
      headerCodeGroup: [],
      headerName: '',
      headerNameGroup: [],
      headerAttCode: '',
      headerAttCodeGroup: [],
      headerAttName: '',
      headerAttNameGroup: [],
      headerVehicleNo: '',
      headerVehicleNoGroup: [],
      headerPrimeMover: '',
      headerPrimeMoverGroup: [],
      headerTotalToll: '',
      headerTotalInc: '',
      headerTimeTaken: '',

      meterStartError: '',
      meterEndError: '',

      mvt: {
        meterStart: '',
        startTime: null,
        meterEnd: '',
        endTime: null,
        toll: '',
        dgc: '',
        remarks: '',
        otherInc: '',
        selectedguid: '',
      },

      tempManualUpdateList: [],

      tempfromToItems: [],
      editTrip: true,
      dateFrom: null,
      dateTo: null,
      editClicked: false,
      updateClicked: false,
      drivers: [],
      refreshList: false,
      basicCom: 0,
      basicComSelected: 0,
      specialInc: 0,
      specialIncSelected: 0,
      otherInc: 0,
      otherIncSelected: 0,
      total: 0,
      totalSelected: 0,

      approveResultMessage: '',
      refreshFlashing: false,
      refreshFlashInterval: null,
      isMounted: false,

      //Trips
      showNewTripPopup: false,
      newTripPopupButtons: [{ text: 'Save' }, { text: 'Cancel', color: 'lightgrey' }],
      tripTypeItems: [{ text: 'Non-Revenue trip' }, { text: 'Revenue trip' }],
      cnList: [],
      trList: [],
      pmList: [],
      driverList: [],
      destinationList: [],
      selectedCN: null,
      selectedTRNo: null,
      selectedPM: null,
      selectedDriver: null,
      selectedFrom: null,
      selectedTo: null,
      selectedFromInput: '',
      selectedToInput: '',
      containerNoInputValue: null,
      tripTypeSelected: null,
      movementTypeSelected: null,
      movementTypeItems: [],
      showFinishTripChkBox: false,
      tripDetailsData: null,
      tripFromDate: null,
      tripToDate: null,
      newTripDriver: null,
      newTripRemarks: '',
      finishTrip: false,
      selectedPMErrMsg: '',

      newTripDriverDisabled: false,
      tripTypeSelectedDisabled: false,
      finishTripDisabled: false,
      selectedCNDisabled: false,
      containerNoInputValueDisabled: false,
      movementTypeSelectedDisabled: false,
      tripFromDateDisabled: false,
      tripToDateDisabled: false,
      selectedFromDisabled: false,
      selectedToDisabled: false,
      newTripRemarksDisabled: false,
      selectedPMDisabled: false,
      selectedTRNoDisabled: false,
      selectedDriverDisabled: false,

      movementTypeCache: {
        NONREVMVT: null,
        REVMVT: null,
      },
    };
  },
  props: {},
  methods: {
    menuClicked: function (e) {
      switch (e.target.innerText.trim()) {
        case 'New Trip': {
          this.showNewTripPopup = true;
          this.tripTypeSelected = this.tripTypeItems[0];
          this.GetTripTypeSelected(this.tripTypeSelected);
          break;
        }

        case 'Cancel Trip(s)': {
          this.cancelTripClicked();
          break;
        }
      }
    },
    selectAllClicked: async function () {
      this.$fullscreenLoading('Getting Trips . . .');
      this.selectedTrip = [];
      if (this.selectedWorkTicketItem.length > 0) {
        this.cardSelectedList = [];
        this.selectedWorkTicketItem = [];
        this.clearHeader();
        this.clearAllField();
      } else {
        this.selectedWorkTicketItem = this.workTicketItem;
        this.cardSelectedList = [];
        //for (let v of this.planBottomData['vehicleList'])
        for (const v of this.workTicketItem) {
          await this.cardClick(v);
        }
        // this.workTicketItem.forEach( workItem =>  {
        //   this.cardClick(workItem);
        // })
        this.selectedWorkTicketItem = this.workTicketItem;
      }
      this.$fullscreenLoading();
    },
    refreshClicked: async function () {
      this.stopRefreshFlash();
      this.fromDateError = '';
      this.toDateError = '';
      this.tempManualUpdateList = [];

      // if(this.tempManualUpdateList.length > 0){
      //   this.$showAlert('warning', 'Are you sure you want to refresh?', 'Refreshing the list will revert your changes for Other Inc value. \nPlease Approve the trip if you want to save your changes.');
      // }else this.tempManualUpdateList = [];
      if (this.selectedField.Field.includes('Date') && this.errorDatePickerCheck()) {
        this.$fullscreenLoading();
        let errorToShow = '';
        if (this.fromDateError == '') {
          errorToShow = this.toDateError;
        } else if (this.toDateError == '') {
          errorToShow = this.fromDateError;
        } else {
          errorToShow = this.fromDateError + '\n' + this.toDateError;
        }
        this.$showAlert('error', 'Invalid Date selection', errorToShow);
        return;
      }
      this.selectedTrip = [];
      this.cardSelectedList = [];
      this.selectedWorkTicketItem = [];
      this.clearHeader();
      this.clearAllField();
      this.basicComSelected = 0;
      this.specialIncSelected = 0;
      this.otherIncSelected = 0;
      this.totalSelected = 0;
      let tempFrom = '';
      if (this.fieldItems) {
        tempFrom = this.selectedFields == null ? '' : this.selectedFields.map((item) => item[this.fromToFullKey]);
      }
      const tempDriver = this.selectedDrivers ? this.selectedDrivers.map((item) => item['Driver']) : '';

      if (
        (!this.hideDriverFilter &&
          !this.useDateInput &&
          (this.selectedFields == null || this.selectedFields.length == 0) &&
          (this.selectedDrivers == null || this.selectedDrivers.length == 0)) ||
        (this.selectedField.Field == 'Driver' && this.selectedFields == null)
      ) {
        // if Driver is chosen
        this.$showAlert('error', 'No Driver Selected', 'Please select at least one driver to proceed');
        return;
      }

      const dataToPost = {
        field: this.fromToFullKey,
        filter: tempFrom != '' ? tempFrom.join(',') : '',
        field2:
          !this.hideDriverFilter || !this.dateFrom ?
            this.fromToFullKey == 'Driver' ?
              ''
            : 'Driver'
          : '',
        filter2:
          (
            this.fromToFullKey == 'Driver' ||
            (this.fromToFullKey == 'Work Ticket #' && Object(this.selectedFields).length > 0)
          ) ?
            ''
          : tempDriver.length > 0 ? tempDriver.join(',')
          : '',
        start: this.dateFrom ? this.dateFrom.formatString('yyyy-MM-dd') : '',
        end: this.dateTo ? this.dateTo.formatString('yyyy-MM-dd') : '',
        list: '1',
      };
      this.workTicketLoading = true;
      this.$fullscreenLoading('Getting Work Tickets . . .');
      this.workTicketItem = [];
      const tempWorkTicketItem = await this.$apiCallV2(`/MovementUpdate/MovementUpdateField`, dataToPost);
      this.workTicketItem = tempWorkTicketItem?.reverse();
      this.workTicketLoading = false;
      this.$fullscreenLoading();
    },
    errorDatePickerCheck: function () {
      if (this.dateFrom == null || this.dateTo == null) {
        this.fromDateError = this.dateFrom != null ? '' : 'From Date is not selected';
        this.toDateError = this.dateTo != null ? '' : 'To Date is not selected';
        return true;
      }
      if (this.dateFrom.getTime() > this.dateTo.getTime()) {
        this.fromDateError = 'From Date cannot be later than To Date';
        this.toDateError = 'From Date cannot be later than To Date';
        return true;
      }
      return false;
    },
    cardClick: async function (cardSelected) {
      this.$fullscreenLoading('Loading Data...');
      this.selectedTrip = [];
      this.cardSelected = [];
      this.cardSelected = cardSelected;
      this.headerDate = '';
      this.headerShift = '';
      this.headerCode = '';
      this.headerName = '';
      this.headerAttCode = '';
      this.headerAttName = '';
      this.headerVehicleNo = '';
      this.headerPrimeMover = '';
      if (!this.refreshList) {
        if (!this.selectedWorkTicketItem.includes(cardSelected)) this.selectedWorkTicketItem.push(cardSelected);
        else {
          const updatedList = this.selectedWorkTicketItem.filter(
            (obj) => JSON.stringify(obj) !== JSON.stringify(cardSelected),
          );
          this.selectedWorkTicketItem = updatedList;
        }
      }

      const getTripListing = {
        driverselection: cardSelected['driver'],
        jiselection: cardSelected['jino'],
        attendantjiselection: cardSelected['jino'],
        post: '0',
        showallentry: '1',
        startdate: cardSelected['jidate'],
        enddate: cardSelected['jidate'],
        processbonusinc: '',
        datetype: '',
        showunapprovedonly: '',
        getactcompletedate: '',
        getalldriver: '0',
        method: '1',
        approvedpayment: '0',
        primemover: cardSelected['primemover'],
      };
      try {
        this.getTripListingItem = await this.$apiCallV2(`/MovementUpdate/GetDriverIncentive`, getTripListing);
        if (this.getTripListingItem['Main']) {
          this.headerDate =
            Object.keys(this.getTripListingItem).length != 0 ? this.getTripListingItem['Main'][0]['JI Date'] : '';
          this.headerShift =
            Object.keys(this.getTripListingItem).length != 0 ? this.getTripListingItem['Main'][0]['Shift'] : '';
          this.headerCode =
            Object.keys(this.getTripListingItem).length != 0 ? this.getTripListingItem['Main'][0]['Driver Code'] : '';
          this.headerName =
            Object.keys(this.getTripListingItem).length != 0 ? this.getTripListingItem['Main'][0]['Driver Name'] : '';
          this.headerAttCode =
            Object.keys(this.getTripListingItem).length != 0 ?
              this.getTripListingItem['Main'][0]['Attendant Code']
            : '';
          this.headerAttName =
            Object.keys(this.getTripListingItem).length != 0 ?
              this.getTripListingItem['Main'][0]['Attendant Name']
            : '';
          this.headerVehicleNo =
            Object.keys(this.getTripListingItem).length != 0 ? this.getTripListingItem['Main'][0]['Vehicle No'] : '';
          this.headerPrimeMover =
            Object.keys(this.getTripListingItem).length != 0 ? this.getTripListingItem['Main'][0]['Prime Mover'] : '';
          this.headerTotalToll =
            Object.keys(this.getTripListingItem).length != 0 ? this.getTripListingItem['Main'][0]['Total Toll'] : '';
          this.headerTotalInc =
            Object.keys(this.getTripListingItem).length != 0 ? this.getTripListingItem['Main'][0]['Total Inc'] : '';
          this.headerTimeTaken =
            Object.keys(this.getTripListingItem).length != 0 ?
              parseFloat(this.getTripListingItem['Main'][0]['Total Time Taken']).toFixed(2)
            : '';

          const tempCardSelectedList =
            Object.keys(this.getTripListingItem).length != 0 ? this.getTripListingItem['Main'][0]['Trips'] : [];
          this.total = (this.basicCom + this.specialInc + this.otherInc).toFixed(2);
          tempCardSelectedList.forEach((c) => {
            Object.keys(c).forEach((k) => {
              if (k == 'Approved?') {
                const data = c[k];
                switch (data) {
                  case 'A':
                    c['Approved?'] =
                      '<div height="15" width="15" style="background-color: green; padding: 5px; border-radius:5px; color: white">Approved</div>';
                    break;
                  default:
                    c['Approved?'] =
                      '<div height="15" width="15" style="background-color: orange; padding: 5px; border-radius:5px; color: white">Pending</div>';
                }
              }
              if (k == 'Payroll') {
                const data = c[k];
                switch (data) {
                  case 'P':
                    c['Payroll'] =
                      '<div height="15" width="15" style="background-color: green; padding: 5px; border-radius:5px; color: white">Paid</div>';
                    break;
                  case 'C':
                    c['Payroll'] =
                      '<div height="15" width="15" style="background-color: lightgray; padding: 5px; border-radius:5px; color: black">Cancelled</div>';
                    break;
                  default:
                    c['Payroll'] =
                      '<div height="15" width="15" style="background-color: lightgray; padding: 5px; border-radius:5px; color: black">New</div>';
                }
              }
              this.tempManualUpdateList.forEach((item) => {
                if (c['JourneyGUID'] == item.journeyguid) {
                  c['Other'] = item.otherinc;
                }
              });
              if (k == 'Premises') {
                const data = c[k];
                switch (data) {
                  case '1':
                    c['Premises'] =
                      '<div height="15" width="15" style="background-color: indianred; padding: 5px; border-radius:5px; color: white">Unsecured</div>';
                    break;
                  default:
                    c['Premises'] =
                      '<div height="15" width="15" style="background-color: ; padding: 5px; border-radius:5px; color: black">Secured</div>';
                }
              }
            });
          });

          this.getTripListingItem['Main'].forEach((driver) => {
            this.headerNameGroup.push(driver['Driver Name']);
            this.headerCodeGroup.push(driver['Driver Code']);
            this.headerAttCodeGroup.push(driver['Attendant Code']);
            this.headerAttNameGroup.push(driver['Attendant Name']);
            this.headerVehicleNoGroup.push(driver['Vehicle No']);
            this.headerPrimeMoverGroup.push(driver['Prime Mover']);
          });
          const tempHeaderNameDriver = Array.from(new Set(this.headerNameGroup));
          const tempHeaderCodeGroup = Array.from(new Set(this.headerCodeGroup));
          const tempheaderAttCodeGroup = Array.from(new Set(this.headerAttCodeGroup));
          const tempheaderAttNameGroup = Array.from(new Set(this.headerAttNameGroup));
          // let tempheaderVehicleNoGroup = Array.from(new Set(this.headerVehicleNoGroup));
          // let tempheaderPrimeMoverGroup = Array.from(new Set(this.headerPrimeMoverGroup));

          this.headerName = tempHeaderNameDriver.join(',');
          this.headerCode = tempHeaderCodeGroup.join(',');
          this.headerAttCode = tempheaderAttCodeGroup.join(',');
          this.headerAttName = tempheaderAttNameGroup.join(',');
          // this.headerVehicleNo = tempheaderVehicleNoGroup.join(',') ;
          // this.headerPrimeMover = tempheaderPrimeMoverGroup.join(',') ;

          if (this.cardSelectedList.length == 0) {
            this.cardSelectedList = tempCardSelectedList;
            this.$fullscreenLoading();
            return;
          }
          const checkDuplicate = this.cardSelectedList.some((trip1) =>
            tempCardSelectedList.some(
              (trip2) => JSON.stringify(trip1['JourneyGUID']) === JSON.stringify(trip2['JourneyGUID']),
            ),
          );

          if (checkDuplicate) {
            const temp = this.cardSelectedList;
            this.cardSelectedList = [];
            tempCardSelectedList.forEach((s) => {
              const index = temp.map((n) => n['JourneyGUID']).indexOf(s['JourneyGUID']);
              temp.splice(index, 1);
            });

            if (this.cardSelectedList.length == 0) {
              this.clearAllField();
              this.clearHeader();
            }

            this.$nextTick(() => {
              this.cardSelectedList = temp;
            });
            // this.cardSelectedList = updatedList;
          } else {
            const temp = this.cardSelectedList;
            tempCardSelectedList.forEach((obj) => {
              temp.push(obj);
            });
            this.cardSelectedList = [];
            this.$nextTick(() => {
              this.cardSelectedList = temp;
            });
          }

          // let newDataFilter = {};
          // newDataFilter['Fileds'] = this.selectedField?.Field;
          // newDataFilter[`${this.selectedField?.Field}`] = this.headerShift ? this.headerShift : '';
          // newDataFilter['Code'] = this.headerCode ? this.headerCode : '';

          // if(this.cardSelectedList.length == 0){
          //   this.clearHeader();
          // }

          this.showTable = false;

          this.$nextTick(() => (this.showTable = true));
        }
        this.$fullscreenLoading();
      } catch {
        this.$fullscreenLoading();
      }
    },
    clearHeader: function () {
      this.headerDate = '';
      this.headerShift = '';
      this.headerCode = '';
      this.headerName = '';
      this.headerAttCode = '';
      this.headerAttName = '';
      this.headerVehicleNo = '';
      this.headerPrimeMover = '';
      this.headerTotalToll = '';
      this.headerTotalInc = '';
      this.headerTimeTaken = '';
      this.headerNameGroup = [];
      this.headerCodeGroup = [];
      this.headerAttCodeGroup = [];
      this.headerAttNameGroup = [];
      this.headerVehicleNoGroup = [];
      this.headerPrimeMoverGroup = [];
      this.basicCom = 0;
      this.specialInc = 0;
      this.otherInc = 0;
      this.total = 0;
    },
    dateChecking: function (dateString) {
      const dateComponents = dateString.length > 10 ? dateString.split(' ') : dateString;

      let year, month, day, hour, minute;

      // Check if date component exists
      if (dateComponents.length > 1) {
        const dateParts = dateComponents[0].split('-');
        year = dateParts[0];
        month = dateParts[1] - 1; // Month is zero-based in JavaScript
        day = dateParts[2];
      } else {
        // Set default values if date component is missing
        const now = new Date();
        year = now.getFullYear();
        month = now.getMonth();
        day = now.getDate();
      }

      // Check if time component exists
      if (dateComponents.length > 1) {
        const timeParts = dateComponents[1].match(/\d{2}/g);
        if (timeParts) {
          hour = timeParts[0];
          minute = timeParts[1];
        } else {
          // Set default values if time component is missing
          hour = 0;
          minute = 0;
        }
      } else {
        // Set default values if time component is missing
        hour = 0;
        minute = 0;
      }

      return new Date(year, month, day, hour, minute);
    },
    additionalTripButtonClicked: async function (btn, data) {
      if (btn == 'Edit') {
        this.selectedTrip = [];
        this.updateClicked = false;
        this.editClicked = true;
        this.editTrip = false;
        if (
          this.removeTag(data['Approved?']) == 'Approved' ||
          this.removeTag(data['Payroll']) == 'Paid' ||
          this.removeTag(data['Payroll']) == 'Cancelled'
        )
          this.disabledOtherInc = true;
        else this.disabledOtherInc = false;
        this.tempfromToItems = await this.$apiCallV2(
          `/MovementUpdate/GetJourneyInstructionDetails?journeyguid=${data['JourneyGUID']}`,
        );
        const from = this.tempfromToItems[0]['From Date'] + ' ' + this.tempfromToItems[0]['From Time'];
        const to = this.tempfromToItems[0]['To Date'] + ' ' + this.tempfromToItems[0]['To Time'];
        if (this.tempfromToItems.length > 0) {
          this.mvt['meterStart'] = this.tempfromToItems[0]['FromSMeter'] ? this.tempfromToItems[0]['FromSMeter'] : '0';
          this.mvt['meterEnd'] = this.tempfromToItems[0]['ToSMeter'] ? this.tempfromToItems[0]['ToSMeter'] : '0';
          this.mvt['startTime'] =
            this.dateChecking(from) != 'Invalid Date' ? this.dateChecking(from)
            : this.dateChecking(to) != 'Invalid Date' ? this.dateChecking(to)
            : this.dateChecking(this.tempfromToItems[0]['JI Date']);
          this.mvt['endTime'] =
            this.dateChecking(to) != 'Invalid Date' ?
              this.dateChecking(to)
            : this.dateChecking(this.tempfromToItems[0]['JI Date']);
          this.mvt['toll'] = this.tempfromToItems[0]['Toll Charges'];
          this.mvt['dgc'] = this.tempfromToItems[0]['DGC Charges'];
          this.mvt['remarks'] = this.tempfromToItems[0]['Remarks'];
          this.mvt['otherInc'] = data['Other'];
          this.mvt['selectedguid'] = data['JourneyGUID'];
          this.mvt['jino'] = data['JINo'];
        }
      } else {
        this.updateClicked = true;
        this.editClicked = false;
      }
    },
    saveButton: async function () {
      if (this.selectedAtt || this.selectedCom || this.refNo || this.selectedTeam) {
        const updateField = [];
        this.selectedTrip.map((item) =>
          updateField.push(`${this.removeTag(item['Mvt'])} \t${this.removeTag(item['CDA #'])}`),
        );
        const tempUpdateField = updateField.map((item) => item).join('\n');
        const updateFieldsName = [];
        if (this.selectedAtt) updateFieldsName.push(`Attendant :${this.selectedAtt['Attendant Code']}`);
        if (this.selectedCom) updateFieldsName.push(`Commission Code:${this.selectedCom['Com Code']}`);
        if (this.refNo) updateFieldsName.push(`Physical Work Ticket Ref #:${this.refNo}`);
        if (this.selectedTeam) updateFieldsName.push(`Commission Code:${this.selectedTeam['Team']}`);

        const tempUpdateFieldName = updateFieldsName.map((item) => item).join('\n');

        const confirmUpdate = await this.$showAlert(
          'warning',
          'Confirm Updates',
          `Are you sure you want to update fields \n\n ${tempUpdateFieldName} \n\nfor the following records \n\n${tempUpdateField} `,
          [{ text: 'Yes' }, { text: 'No' }],
        );

        if (confirmUpdate == 'No') return;
      }
      if (this.mvt['remarks'].length > 200) {
        this.$showAlert('error', 'Invalid Input', 'Remarks cannot exceed 200 characters');
        return;
      }
      if (parseFloat(this.mvt['meterStart']) > 90000000000000000) {
        this.meterStartError = 'Meter Start value is too large!';
        // this.$showAlert('error', 'Invalid Input', 'Meter Start value is too large!');
        return;
      }

      if (parseFloat(this.mvt['meterEnd']) > 90000000000000000) {
        this.meterEndError = 'Meter End value is too large!';
        // this.$showAlert('error', 'Invalid Input', 'Meter End value is too large!');
        return;
      }
      // if (this.errorDatePickerCheck('')){
      //   this.$showAlert('error', 'Invalid Date selection', 'Start Date Cannot be later than End date');
      //   return;
      // }
      const dataToPost = {
        fromdatetime: this.mvt['startTime'] ? this.mvt['startTime'].formatString('yyyy-MM-dd HHmm') : '',
        todatetime: this.mvt['endTime'] ? this.mvt['endTime'].formatString('yyyy-MM-dd HHmm') : '',
        journeyguid: this.removeTag(this.mvt['selectedguid']),
        fromsmeter: this.mvt['meterStart'],
        tosmeter: this.mvt['meterEnd'],
        tollcharges: this.mvt['toll'],
        dgccharges: this.mvt['dgc'],
        remarks: this.mvt['remarks'],
        otherinc: this.mvt['otherInc'],
        attendant: this.selectedAtt ? this.selectedAtt['Attendant Code'] : null,
        commission: this.selectedCom ? this.selectedCom['Com Code'] : null,
        refno: this.refNo ? this.refNo : null,
        team: this.selectedTeam ? this.selectedTeam['Team'] : null,
      };

      const currentJINo = this.mvt['jino'];
      this.tempManualUpdateList.push({
        otherinc: this.mvt['otherInc'] ? this.mvt['otherInc'] : '0.00',
        journeyguid: this.removeTag(this.mvt['selectedguid']),
      });

      const result = await this.$apiCallV2(`/MovementUpdate/MovementUpdateJIDetails`, dataToPost);
      if (result[0]['Results'] == 0) {
        this.cancelButton();
        this.clearHeader();
        this.clearAllField();
        const tempCardSelectedList = JSON.parse(
          JSON.stringify(this.cardSelectedList.filter((f) => f['JINo'] != currentJINo)),
        );
        this.cardSelectedList = [];
        this.refreshList = true;
        const temp = this.selectedWorkTicketItem;
        this.selectedWorkTicketItem = [];
        const tempItem = temp.find((f) => f['jino'] == currentJINo);

        await this.cardClick(tempItem);
        // this.cardSelectedList.concat(tempCardSelectedList);
        this.cardSelectedList.forEach((i) => {
          tempCardSelectedList.push(i);
        });
        // tempCardSelectedList.forEach(i => {
        //   console.log(i);
        //   this.cardSelectedList.push(i);
        // })
        this.cardSelectedList = [];
        this.$nextTick(() => (this.cardSelectedList = JSON.parse(JSON.stringify(tempCardSelectedList))));

        // this.cardSelectedList.push(tempCardSelectedList);
        // temp.forEach( async item => await this.cardClick(item));
        this.selectedWorkTicketItem = temp;
        this.refreshList = false;
        this.selectedTrip = [];
        this.startDateError = '';
        this.endDateError = '';
        this.$showAlert('success', 'Success', 'Successfully Update Trip Details.');
        this.clearAllField();
      } else {
        this.$showAlert('error', 'An Error has occurred', result[0]['ErrMsg']);
      }
    },
    cancelButton: function () {
      this.editClicked = false;
      this.updateClicked = false;
      this.clearAllField();
    },
    clearAllField: function () {
      this.mvt['meterStart'] = '';
      this.mvt['startTime'] = null;
      this.mvt['meterEnd'] = '';
      this.mvt['endTime'] = null;
      this.mvt['toll'] = '';
      this.mvt['dgc'] = '';
      this.mvt['remarks'] = '';
      this.mvt['otherInc'] = '';
      this.mvt['selectedguid'] = '';
      this.mvt['jino'] = '';
      this.selectedAtt = null;
      this.selectedCom = null;
      this.refNo = '';
      this.selectedTeam = null;
    },
    approveClicked: function (type) {
      this.$fullscreenLoading(`${type == 'approved' ? 'Approving' : 'Unapproving'} trip(s)...`);
      this.tempResultError = [];
      if (this.selectedTrip.length > 0) {
        const grouping = [...new Set(this.selectedTrip.map((s) => s['JINo']))]; //Group all selected trips by jino
        const manualupdateGroup = this.selectedTrip.map((s) => {
          return {
            journeyguid: s['JourneyGUID'],
            basic: s['Basic'],
            special: s['Special'],
            other: s['Other'],
            attbasic: s['AttnBasic'],
          };
        });
        grouping.forEach(async (g) => {
          const groupitems = this.selectedTrip.filter((val) => val['JINo'] == g); //loop the approval update by jino
          const tempSelectedWorkTicketItem = this.selectedWorkTicketItem.filter((item) => item.jino == g);
          const getTripListing = {
            driverselection: tempSelectedWorkTicketItem[0]['driver'],
            jiselection: g,
            attendantjiselection: g,
            post: '0',
            showallentry: '1',
            startdate: tempSelectedWorkTicketItem[0]['jidate'],
            enddate: tempSelectedWorkTicketItem[0]['jidate'],
            processbonusinc: '',
            datetype: '',
            showunapprovedonly: '',
            getactcompletedate: '',
            getalldriver: '0',
            method: '1',
            approvedpayment: type == 'cancel' ? '2' : '1',
            primemover: tempSelectedWorkTicketItem[0]['primemover'],
            journeyguid: groupitems.map((item) => item.JourneyGUID).join(','),
            manualupdate: !this.disabledOtherInc ? '1' : '0',
            manualupdatelist: manualupdateGroup,
          };
          // console.log(getTripListing);
          const temp = await this.$apiCallV2(`/MovementUpdate/GetDriverIncentive`, getTripListing);
          if (temp[0]['Results'] == 1) {
            this.approveResultMessage = `${this.approveResultMessage}${new Date().formatString('yyyy-MM-dd HH:mm:ss')}| ${temp[0]['ErrMsg']}\n`;
            this.tempResultError.push(temp[0]['ErrMsg']);
          }
        });

        setTimeout(() => {
          this.linkCopied = false;
          this.clearHeader();
          this.clearAllField();
          this.tempManualUpdateList = [];
          this.cardSelectedList = [];
          this.refreshList = true;
          const temp = this.selectedWorkTicketItem;
          this.selectedWorkTicketItem = [];
          temp.forEach(async (item) => await this.cardClick(item));
          this.selectedWorkTicketItem = temp;
          this.refreshList = false;
          this.selectedTrip = [];

          // console.log(this.tempResultError);
          // if(this.tempResultError){
          //   this.reconstructErrMsg(this.tempResultError);
          // }
        }, 2000);
        this.tempResultError = [];
      } else {
        let text = '';
        this.$fullscreenLoading();
        text =
          type == 'cancel' ?
            'Please select any record to Unapprove trip(s)'
          : 'Please select any trip(s) to Approve trip(s)';
        this.$showAlert('error', 'No record is selected', text);
      }
    },
    removeTag: function (item) {
      // Regular expression to extract the string within the <div> tag
      const regex = /<div[^>]*>([^<]+)<\/div>/i;

      // Extract the string using regex and capture group
      const match = item.match(regex);
      let extractedString = '';
      // Check if a match is found
      if (match && match.length > 1) {
        extractedString = match[1];
      } else {
        extractedString = item;
      }
      return extractedString;
    },
    newTripPopupSaveClicked: async function (_btn) {
      if (_btn === 'Cancel' || _btn === 'Close') {
        this.showNewTripPopup = false;
        this.clearNewTripFields();
        return;
      }

      const validations = [
        { condition: !this.selectedCN, title: 'No Consignment Selected', message: 'Please select a consignment' },
        {
          condition: !this.movementTypeSelected,
          title: 'No Movement Type Selected',
          message: 'Please select a movement type!',
        },
        {
          condition: !this.selectedFrom,
          title: 'No From Destination Selected',
          message: 'Please select a destination code!',
        },
        {
          condition: !this.selectedTo,
          title: 'No To Destination Selected',
          message: 'Please select a destination code!',
        },
      ];

      for (const v of validations) {
        if (v.condition) {
          this.$showAlert('error', v.title, v.message, [{ text: 'OK' }]);
          return;
        }
      }

      if (!this.selectedPM && this.selectedWorkTicketItem.length != 1) {
        this.selectedPMErrMsg = 'Prime mover is required';
        return;
      }

      let requestBody = {
        action: 'N',
        trip: this.tripTypeSelected['text'],
        cnno: this.selectedCN['Consignment #'],
        jino: this.selectedWorkTicketItem.length != 1 ? '' : this.selectedWorkTicketItem[0]['jino'],
        jidate: this.selectedWorkTicketItem.length != 1 ? '' : this.selectedWorkTicketItem[0]['jidate'],
        movementtype: this.movementTypeSelected['MovementType'],
        contno: this.containerNoInputValue,
        driver:
          this.showDriverField ? this.newTripDriver['Driver']
          : !this.hideDriverFilter ? this.selectedDrivers[0]['Driver']
          : this.selectedFields[0]['Driver'],
        pm:
          this.selectedWorkTicketItem.length != 1 ?
            this.selectedPM['PM Code']
          : this.selectedWorkTicketItem[0]['primemover'],
        trno: this.selectedTRNo ? this.selectedTRNo['Trailer #'] : '',
        shift: this.workTicketItem.length != 1 ? '' : this.getTripListingItem['Main'][0]['Shift'],
        from: this.selectedFrom['Location Code'],
        to: this.selectedTo['Location Code'],
        fromdate: new Date(this.tripFromDate).formatString('yyyy-MM-dd'),
        fromtime: new Date(this.tripFromDate).formatString('HHmm'),
        todate: new Date(this.tripToDate).formatString('yyyy-MM-dd'),
        totime: new Date(this.tripToDate).formatString('HHmm'),
        remarks: this.newTripRemarks,
        finishtrip: this.finishTrip,
      };

      const oriRequestBody = requestBody;
      this.$fullscreenLoading(`Saving Movement`);
      const result1 = await this.$apiCallV2('/MovementUpdate/SaveMovementUpdate', requestBody);
      this.$fullscreenLoading();

      if (result1[0]['Results'] == '2') {
        const confirm = await this.$showAlert('warning', 'Duplicate Record', result1[0]['ErrMsg'], [
          { text: 'Yes' },
          { text: 'No', color: 'grey', textColor: 'white' },
        ]);

        if (confirm == 'No') {
          return;
        }

        requestBody = {
          ...requestBody,
          duplicate: '0',
        };
      } else if (result1[0]['Results'] == '1') {
        this.$showAlert('error', 'Movement Save Error', 'Movement could not be saved', [{ text: 'OK' }]);
      } else {
        this.$showAlert('success', 'Movement Saved', 'Movement has been successfully saved', [{ text: 'OK' }]);
        this.tripDisabled();
        this.newTripPopupButtons = [{ text: 'Close' }];
        const previouslySelected = [...this.selectedWorkTicketItem];
        const newTripJino = requestBody.jino;
        const newTripDriver = requestBody.driver;
        const newTripPM = requestBody.pm;
  
        this.cardSelectedList = [];
        this.selectedWorkTicketItem = [];
        this.selectedTrip = [];
        this.clearHeader();
        this.clearAllField();

        await this.refreshClicked();

        const newCard = this.workTicketItem.find(w =>
          (newTripJino ? w['jino'] === newTripJino : true) &&
          w['driver'] === newTripDriver &&
          w['primemover'] === newTripPM
        );

        const validItems = this.workTicketItem.filter(refreshedItem =>
          previouslySelected.some(prev => prev['jino'] === refreshedItem['jino'])
        );

        if (newCard && !validItems.some(v => v['jino'] === newCard['jino'])) {
          validItems.push(newCard);
        }

        if (validItems.length > 0) {
          this.selectedWorkTicketItem = [];
          this.cardSelectedList = [];
          this.refreshList = true;

          for (const item of validItems) {
            await this.cardClick(item);
          }

          this.refreshList = false;
          this.selectedWorkTicketItem = validItems;
          this.selectedTrip = [];
        } else {
          this.startRefreshFlash();
        }
      }

      if (Object.keys(oriRequestBody).length != Object.keys(requestBody).length) {
        this.$fullscreenLoading(`Saving Movement`);
        const result2 = await this.$apiCallV2('/MovementUpdate/SaveMovementUpdate', requestBody);
        this.$fullscreenLoading();

        if (result2[0]['Results'] == '1') {
          this.$showAlert('error', 'Movement Save Error', 'Movement could not be save', [{ text: 'OK' }]);
        } else {
          this.$showAlert('success', 'Movement Saved', 'Movement has been successfully saved', [{ text: 'OK' }]);
          this.tripDisabled();
          this.newTripPopupButtons = [{ text: 'Close' }];
          const previouslySelected = [...this.selectedWorkTicketItem];
          const newTripJino = requestBody.jino;
          const newTripDriver = requestBody.driver;
          const newTripPM = requestBody.pm;
    
          this.cardSelectedList = [];
          this.selectedWorkTicketItem = [];
          this.selectedTrip = [];
          this.clearHeader();
          this.clearAllField();

          await this.refreshClicked();

          const newCard = this.workTicketItem.find(w =>
            (newTripJino ? w['jino'] === newTripJino : true) &&
            w['driver'] === newTripDriver &&
            w['primemover'] === newTripPM
          );

          const validItems = this.workTicketItem.filter(refreshedItem =>
            previouslySelected.some(prev => prev['jino'] === refreshedItem['jino'])
          );

          if (newCard && !validItems.some(v => v['jino'] === newCard['jino'])) {
            validItems.push(newCard);
          }

          if (validItems.length > 0) {
            this.selectedWorkTicketItem = [];
            this.cardSelectedList = [];
            this.refreshList = true;

            for (const item of validItems) {
              await this.cardClick(item);
            }

            this.refreshList = false;
            this.selectedWorkTicketItem = validItems;
            this.selectedTrip = [];
          } else {
            this.startRefreshFlash();
          }
        }
      }
    },
    cancelTripClicked: async function () {
      if (this.selectedTrip.length < 1) {
        this.$showAlert('error', 'No Trip Selected', 'Please select at least one trip to cancel');
        return;
      }

      let requestBody = {
        action: 'D',
        cancelji: this.selectedTrip.map((ji) => ({
          cnno: ji['CDA #'],
          jino: ji['JINo'],
          movementtype: ji['Mvt'],
          jiguid: ji['JourneyGUID'],
          ind: ji['Ind'],
          seqno: ji['Seq No'],
          jobno: ji['Job #'],
          pm: ji['PM'],
          driver: this.selectedWorkTicketItem.find((w) => w.jino === ji['JINo'])?.driver ?? '',
        })),
      };

      this.$fullscreenLoading(`Cancel Movement`);
      const result = await this.$apiCallV2('/MovementUpdate/SaveMovementUpdate', requestBody);
      this.$fullscreenLoading();

      if (result[0]['Results'] == '2') {
        const confirm = await this.$showAlert('warning', 'Confirm Cancellation of Trip?', result[0]['ErrMsg'], [
          { text: 'Yes' },
          { text: 'No', color: 'grey', textColor: 'white' },
        ]);

        if (confirm == 'No') {
          return;
        }

        requestBody = {
          ...requestBody,
          confirm: true,
        };
      }

      this.$fullscreenLoading(`Cancel Movement`);
      const result2 = await this.$apiCallV2('/MovementUpdate/SaveMovementUpdate', requestBody);
      this.$fullscreenLoading();

      if (result2[0]['Results'] == '1') {
        this.$showAlert('error', 'Movement Cancel Error', 'Movement could not be cancel', [{ text: 'OK' }]);
      } else {
        this.cancelButton();
        this.clearHeader();
        this.clearAllField();
        this.cardSelectedList = [];

        const previouslySelected = [...this.selectedWorkTicketItem];
        this.selectedWorkTicketItem = [];
        this.selectedTrip = [];

        await this.refreshClicked();
        const validItems = this.workTicketItem.filter(refreshedItem =>
          previouslySelected.some(prev => prev['jino'] === refreshedItem['jino'])
        );

        if (validItems.length > 0) {
          this.selectedWorkTicketItem = [];
          this.cardSelectedList = [];
          this.refreshList = true; 

          for (const item of validItems) {
            await this.cardClick(item);
          }

          this.refreshList = false;
          this.selectedWorkTicketItem = validItems;
          this.selectedTrip = [];
        } else {
          this.startRefreshFlash();
        }
      }
    },
    viewCNDetClicked: function () {
      const viewCNDetailURL = `/Home/${this.$route.params.user}/Haulage/Consignment?cnno=${this.selectedCN['Consignment #']}`;
      const resolvedViewCNDetailRoute = this.$router.resolve(viewCNDetailURL);
      window.open(resolvedViewCNDetailRoute.href, '_blank');
    },
    GetTripTypeSelected: async function (e) {
      const isNonRevenue = e.text === 'Non-Revenue trip';
      const masterfile = isNonRevenue ? 'NONREVMVT' : 'REVMVT';

      this.showFinishTripChkBox = !isNonRevenue;

      if (!this.movementTypeCache[masterfile]) {
        this.$fullscreenLoading('Getting Movement');
        const result = await this.$apiCallV2('/Master/GetListMaster', {
          masterfile: masterfile,
        });
        this.$fullscreenLoading();

        this.movementTypeCache[masterfile] = result.map((item) => ({
          ...item,
          'Movement - Movement Desc': `${item.MovementType} - ${item.MovementTypeDesc}`,
        }));
      }

      this.movementTypeItems = this.movementTypeCache[masterfile];
      this.movementTypeSelected = this.movementTypeItems[0];
    },
    CNNoSelected: async function (e) {
      this.$fullscreenLoading('Getting Trip Details');
      const cn = e ?? this.selectedCN;
      if (cn) {
        if (e) {
          this.tripDetailsData = await this.$apiCallV2(
            `/MovementUpdate/GetQuickFindMovementDetails?consignmentNo=${cn['Consignment #'].trim()}`,
          );
          this.containerNoInputValue = this.tripDetailsData[0]['Container No'];
        }

        const trips = this.tripDetailsData;
        const movementType = this.movementTypeSelected?.['MovementType'];

        let tripIndex = 0;
        if (movementType == 'C1W') tripIndex = 1;
        else tripIndex;

        const selectedTrip = trips[tripIndex]['Trips'][0];

        this.selectedFrom = this.destinationList.find((i) => i['Location Code'] == selectedTrip?.['From Location']);
        this.selectedFromInput = this.selectedFrom?.['Location Code'] ?? '';

        this.selectedTo = this.destinationList.find((i) => i['Location Code'] == selectedTrip?.['To Location']);
        this.selectedToInput = this.selectedTo?.['Location Code'] ?? '';

        this.tripFromDate = this.tripToDate = new Date(selectedTrip?.['Work Ticket Date']);

        if (e && this.tripTypeSelected?.text !== 'Non-Revenue trip') {
          this.movementTypeSelected = this.movementTypeItems.find((i) => i['MovementType'] == selectedTrip['Movement']);
        }
      }

      this.$fullscreenLoading();
    },
    tripDisabled: function () {
      this.newTripDriverDisabled = true;
      this.tripTypeSelectedDisabled = true;
      this.finishTripDisabled = true;
      this.selectedCNDisabled = true;
      this.containerNoInputValueDisabled = true;
      this.movementTypeSelectedDisabled = true;
      this.tripFromDateDisabled = true;
      this.tripToDateDisabled = true;
      this.selectedFromDisabled = true;
      this.selectedToDisabled = true;
      this.newTripRemarksDisabled = true;
      this.selectedPMDisabled = true;
      this.selectedTRNoDisabled = true;
      this.selectedDriverDisabled = true;
    },
    clearNewTripFields: function () {
      this.newTripPopupButtons = [{ text: 'Save' }, { text: 'Cancel', color: 'lightgrey' }];

      this.selectedCN = null;
      this.selectedTRNo = null;
      this.selectedPM = null;
      this.selectedDriver = null;
      this.selectedFrom = null;
      this.selectedTo = null;
      this.selectedFromInput = '';
      this.selectedToInput = '';
      this.containerNoInputValue = null;
      this.tripTypeSelected = null;
      this.movementTypeSelected = null;
      this.movementTypeItems = [];
      this.showFinishTripChkBox = false;
      this.tripDetailsData = null;
      this.tripFromDate = null;
      this.tripToDate = null;
      this.newTripDriver = null;
      this.newTripRemarks = '';
      this.finishTrip = false;
      this.selectedPMErrMsg = '';

      this.newTripDriverDisabled = false;
      this.tripTypeSelectedDisabled = false;
      this.finishTripDisabled = false;
      this.selectedCNDisabled = false;
      this.containerNoInputValueDisabled = false;
      this.movementTypeSelectedDisabled = false;
      this.tripFromDateDisabled = false;
      this.tripToDateDisabled = false;
      this.selectedFromDisabled = false;
      this.selectedToDisabled = false;
      this.newTripRemarksDisabled = false;
      this.selectedPMDisabled = false;
      this.selectedTRNoDisabled = false;
      this.selectedDriverDisabled = false;
    },
    movementTypeChange: async function () {
      await this.CNNoSelected();
    },
    startRefreshFlash: function () {
      if (this.refreshFlashInterval) return;
      this.refreshFlashing = false;
      this.refreshFlashInterval = setInterval(() => {
        this.refreshFlashing = !this.refreshFlashing;
      }, 500);
    },
    stopRefreshFlash: function () {
      if (this.refreshFlashInterval) {
        clearInterval(this.refreshFlashInterval);
        this.refreshFlashInterval = null;
      }
      this.refreshFlashing = false;
    },
  },
  async mounted() {
    // setTimeout(() => {
    this.topHeight = this.$refs['top-height'].getBoundingClientRect().height;
    this.leftContainer = this.$refs['left-container'].getBoundingClientRect().height;
    this.sectionHeight = this.$refs['botttom-right-container'].getBoundingClientRect().height - 90;
    this.tableBoxHeight = this.$refs['select-by-cont-box'].getBoundingClientRect().height;
    this.topSecHeight = this.$refs['top-right-container'].getBoundingClientRect().height;
    // }, 300);
    this.$fullscreenLoading('Getting Movement Update Data');
    this.fieldItemsOption = this.$deepTrimJsonV3(
      await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'MOVEMENTUPDATEFIELD' }),
    );
    this.selectedField = this.fieldItemsOption ? this.fieldItemsOption[0] : [];
    this.attItemsOption = this.$deepTrimJsonV3(
      await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'ATTENDANT', module: 'HMS' }),
    );
    this.comItemsOption = this.$deepTrimJsonV3(
      await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'LORRYCOMISSION' }),
    );
    this.teamItemsOption = this.$deepTrimJsonV3(await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'TEAM' }));

    const dataToPost = {
      field: 'Driver',
      start: '',
      end: '',
      list: '0',
    };

    this.drivers = await this.$apiCallV2(`/MovementUpdate/MovementUpdateField`, dataToPost);
    // this.selectedField = this.fieldItems[0]

    //Assign selectedField from URL
    if (this.$route.query['field']) {
      // this.selectedWorkTicketItem
      this.selectedField = await this.fieldItemsOption.find((i) => {
        return i['Field'] == this.$route.query['field'];
      });
    }

    this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTDRIVER' }).then((result) => {
      this.driverList = result.map((driver) => ({
        ...driver,
        'Code - Name': `${driver['Driver Code']} - ${driver['Driver Name']}`,
      }));
    });

    this.$fullscreenLoading('Getting Consignment No');
    this.cnList = await this.$apiCallV2('/Master/GetListMaster', {
      masterfile: 'MOVEMENTUPDATECN',
    });

    this.$fullscreenLoading('Getting Available Trailer No');
    await this.$apiCallV2('/Master/GetListMaster', {
      masterfile: 'AVAILABLETR',
    }).then((result) => {
      this.trList = result.map((item) => {
        return {
          ...item,
          'Trailer # - Trailer Code': `${item['Trailer #']} - ${item['Trailer Code']}`,
        };
      });
    });

    // if (this.selectedWorkTicketItem.length != 1) {
    this.$fullscreenLoading('Getting PM');
    await this.$apiCallV2('/Master/GetListMaster', {
      masterfile: 'PMCODE',
    }).then((result) => {
      this.pmList = result.map((item) => {
        return {
          ...item,
          'PM Code - PM Number': `${item['PM Code']} - ${item['PM Number']}`,
        };
      });
    });
    // }

    this.$fullscreenLoading('Getting Destination');
    this.destinationList = await this.$apiCallV2('/Master/GetListMaster', {
      masterfile: 'JINEWTRIPDESTINATION',
    });

    this.$fullscreenLoading();
    this.isMounted = true;

    // this.$refs('driverFilter').setFocus();
  },
  watch: {
    // Apply Work Ticket filter from URL query once fieldItems are loaded
    fieldItems: async function (val) {
      if (this.$route.query['workTicket'] && this.selectedField?.Field.includes('Work Ticket')) {
        const wt = this.$route.query['workTicket'];

        const match = val.find((i) => String(i[this.fromToFullKey]) === String(wt));

        if (match) {
          this.selectedFields = [match]; // Filters expects array
          await this.refreshClicked();
          await this.selectAllClicked();
        }
      }
    },
    selectedFields: function (val) {
      if (this.isMounted && val?.length > 0 && this.selectedField) {
        this.startRefreshFlash();
      } else {
        this.stopRefreshFlash();
      }

      if (
        (val?.length > 0 && this.selectedField.Field.includes('Work Ticket #')) ||
        this.selectedField.Field.includes('Driver')
      ) {
        this.hideDriverFilter = true;
        this.selectedDrivers = null;
        return;
      }
      this.hideDriverFilter = false;
    },
    selectedField: async function (val) {
      if (val) {
        this.$fullscreenLoading('Getting Data');
        this.selectedFields = null;
        if (val.Field.includes('Date')) {
          this.useDateInput = true;
          this.dateFrom = new Date();
          this.dateTo = new Date();
        } else {
          this.useDateInput = false;
          this.dateFrom = null;
          this.dateTo = null;
        }

        if (this.allChecked) this.refreshClicked();

        if (val.Field.includes('Driver')) {
          this.hideDriverFilter = true;
          this.selectedDrivers = null;
        } else {
          this.hideDriverFilter = false;
        }
        const dataToPost = {
          field: val.Field,
          start: '',
          end: '',
          list: '0',
        };

        const tempfromToItems = await this.$apiCallV2(`/MovementUpdate/MovementUpdateField`, dataToPost);
        // setTimeout(() => {
        //   this.tableBoxHeight = this.$refs['select-by-cont-box'].getBoundingClientRect().height;
        // }, 300);
        this.fromToFullKey = val.Field;
        if (Array.isArray(tempfromToItems)) {
          this.fieldItems = tempfromToItems.filter((item) => item[val.Field] !== '');
        } else {
          this.fieldItems = [];
        }

        this.$fullscreenLoading();
      }
    },
    selectedTrip: function (val) {
      this.$nextTick(() => {
        this.basicComSelected = 0;
        this.specialIncSelected = 0;
        this.otherIncSelected = 0;
        this.totalSelected = 0;

        if (val.length > 1) {
          this.multipleUpdate = true;
        } else {
          this.clearAllField();
        }

        val.forEach((obj) => {
          const basic = parseFloat(this.removeTag(obj.Basic));
          const special = parseFloat(this.removeTag(obj.Special));
          const other = parseFloat(this.removeTag(obj.Other));
          if (!isNaN(basic)) {
            (this.basicComSelected += basic).toFixed(2);
          }
          if (!isNaN(special)) {
            (this.specialIncSelected += special).toFixed(2);
          }
          if (!isNaN(other)) {
            (this.otherIncSelected += other).toFixed(2);
          }
        });
        this.totalSelected = parseFloat(
          this.basicComSelected + this.specialIncSelected + this.otherIncSelected,
        ).toFixed(2);
        this.loadingTable = true;
      });
    },
    selectedWorkTicketItem: function (val) {
      // list of selected work ticket / card selected
      if (val.length == 0) {
        this.$nextTick(() => {
          this.clearHeader();
          this.clearAllField();
        });
      }
    },
    cardSelectedList: function (val) {
      // list of trips for selected work ticket
      this.cardlistLoading = true;
      this.basicCom = 0;
      this.specialInc = 0;
      this.otherinc = 0;
      this.total = 0;
      val.forEach((obj) => {
        const basic = parseFloat(this.removeTag(obj.Basic));
        const special = parseFloat(this.removeTag(obj.Special));
        const other = parseFloat(this.removeTag(obj.Other));
        if (!isNaN(basic)) {
          parseFloat((this.basicCom += basic)).toFixed(2);
        }
        if (!isNaN(special)) {
          parseFloat((this.specialInc += special)).toFixed(2);
        }
        if (!isNaN(other)) {
          parseFloat((this.otherInc += other)).toFixed(2);
        }
      });
      this.total = parseFloat(this.basicCom + this.specialInc + this.otherInc).toFixed(2);
      this.cardlistLoading = false;
    },
    approveResultMessage: function () {
      this.$nextTick(() => (this.$refs.msgbox.scrollTop = this.$refs.msgbox.scrollHeight + 100));
    },
    tripTypeSelected: async function (val) {
      if (val && this.selectedCN && this.tripDetailsData) {
        await this.GetTripTypeSelected(val);
        await this.CNNoSelected();
      }
    },
    filtersSnapshot: function () {
      if (this.isMounted) {
        this.startRefreshFlash();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.main {
  font-size: 12px;
  width: 200px;
  height: 100%;
  padding: 10px 45px;
  display: flex;
  overflow: hidden;

  > .left-container {
    border-radius: 5px;
    max-width: 255px;
    width: 100%;
    background-color: white;
    margin-right: 5px;
    height: 100%;
    transition: 0.3s;
    padding: 4px;
    display: flex;
    flex-direction: column;

    .menu-action {
      margin-bottom: 5px;
      display: block;
      text-align: left;
      width: 100%;

      > .menu-action-icon {
        height: 20px;
        width: 20px;
      }
    }

    > .separator {
      height: 20px;
    }

    > .buttons-style {
      padding-bottom: 5px;
    }

    > .work-ticket-section {
      border: 1px solid rgb(200, 200, 200);
      border-radius: 5px;
      padding: 5px;
      width: 100%;
      display: flex;
      flex-direction: column;

      > .container {
        display: flex;
        // justify-content: center;
        // align-items: center;
        width: 100%;
        padding: 0px;

        > .container-one {
          // margin-left: -15px;
          // margin-right: 2px;
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  > .right-container {
    border-radius: 5px;
    width: 100%;
    height: 100%;
    overflow: hidden;

    > .top-right-container {
      width: 100%;
      border-radius: 5px;
      height: 80px;
      background-color: white;
      margin-bottom: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > .filtered-section {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding-left: 5px;

        > .filtered-items {
          background-color: white;
          display: flex;
          position: relative;
          margin-bottom: 3px;
          width: 100%;

          > :nth-child(1) {
            padding-right: 3px;
          }
          > .filter-title {
            width: 100px;
          }
          > .filter-title-left {
            width: 200px;
          }
          > .filter-details {
            height: 18px;
            width: fit-content;
            display: flex;
            flex-direction: row;
          }
        }
      }
    }

    > .botttom-right-container {
      width: 100%;
      height: calc(100% - 85px);
      margin-bottom: 5px;
      padding: 5px;
      border-radius: 5px;
      background-color: white;
      display: flex;
      flex-direction: column;

      > .botttom-right-container-top {
        // background-color: red;
        position: relative;
        display: flex;
        flex-direction: row;
        // height: 100%;
      }
      > .botttom-right-container-bottom {
        height: 85px;
        // height: calc(100% - 85px);
        // bottom: 0;
        // margin-bottom: 10px;
        // background-color: green;
        // display: flex;
        // flex-direction: column;
        // width: 100%;
        // justify-content: flex-end;

        > .buttons-section {
          display: flex;
          flex-direction: row;

          > .message-box {
            flex-grow: 1;
            background-color: rgba(255, 246, 121, 0.37);
            overflow: auto;
            // height: 100%;
            width: 100%;
            white-space: pre-wrap;
            padding: 5px;
            margin: 5px;
            height: 80px;
          }
        }
      }
    }
  }

  > .card {
    // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    background-color: white;
    border: 2px solid black;
    padding: 16px;
    text-align: center;
    border-radius: 0px;
    // background-color: #bfb9b9;
    // height: fit-content;
    margin-bottom: 6px;

    > .card-filtered-items {
      margin: 5px;

      > :nth-child(1) {
        padding-right: 10px;
      }

      > .filter-title {
        width: 20%;
      }
    }
  }

  .card:hover {
    background-color: #b3c4ff;
    cursor: pointer;
    // left: calc(200px - 100%);
  }

  .selected-card-styling {
    margin-bottom: '4px';
    cursor: 'pointer';
    background-color: rgb(120, 120, 255);
    color: white;
  }
  .cardlist-styling {
    margin-top: 5px;
    padding: 3px;
    background-color: lightgray;
    height: 100%;
    overflow: auto;
  }

  .deselect-card-styling {
    margin-bottom: '4px';
    cursor: 'pointer';
    background-color: '';
    color: '';
  }

  .section-loader {
    background-color: rgba(200, 200, 200, 0.3);
    // background-color: rgba(203, 15, 15, 0.3);
    z-index: 999;
    position: absolute;
    width: 245px;
    height: 100%;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    overflow: hidden;

    > .section-loader-text {
      background-color: white;
      border-radius: 5px;
      user-select: none;
      box-shadow: 0 0 8px #0004;
      font-size: 12px;
      display: flex;
      width: fit-content;
      padding: 5px;
    }
  }

  .popup-body {
    padding: 5px;

    > .form-row {
      display: flex;
      flex-direction: row;
      padding: 0 5px 0 5px;

      > .input-field {
        margin-right: 6px;
      }
    }
  }
}

.refresh-flashing {
  background-color: #8c8cff !important;
  transition: background-color 0.3s ease;
}
</style>
